var _rect, _rect2, _rect3, _rect4, _rect5, _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3, _ellipse4, _path4, _path5, _rect6, _rect7, _rect8, _path6, _path7, _rect9, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 360,
    viewBox: "0 0 361 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 360,
    height: 360,
    rx: 180,
    fill: "#F6F8FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.1953,
    y: 86.7031,
    width: 102.312,
    height: 69.8392,
    rx: 11.134,
    fill: "#E2E4E9",
    stroke: "#868C98",
    strokeWidth: 2.43243,
    strokeMiterlimit: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 197.265,
    y: 99.6064,
    width: 96.5532,
    height: 65.9084,
    rx: 9.27836,
    fill: "#F6F8FA",
    stroke: "#868C98",
    strokeWidth: 2.43243,
    strokeMiterlimit: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 136.495,
    y: 218.558,
    width: 166.371,
    height: 65.1794,
    rx: 11.134,
    fill: "#CDD0D5",
    stroke: "#868C98",
    strokeWidth: 2.43243,
    strokeMiterlimit: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 77.915,
    y: 111.769,
    width: 204.184,
    height: 139.379,
    rx: 11.134,
    fill: "white",
    stroke: "#868C98",
    strokeWidth: 2.43243,
    strokeMiterlimit: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.6235,
    cy: 125.671,
    rx: 4.04883,
    ry: 4.04883,
    fill: "#E2E4E9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.333,
    cy: 125.671,
    rx: 4.04883,
    ry: 4.04883,
    fill: "#E2E4E9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.044,
    cy: 125.671,
    rx: 4.04883,
    ry: 4.04883,
    fill: "#E2E4E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.869 153.373L136.497 145.759L113.869 138.421L92.4204 145.759L113.869 153.373Z",
    fill: "#868C98",
    stroke: "#868C98",
    strokeWidth: 2.43243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0444 151.442L114.336 156.956L129.051 152.051L129.786 162.369C129.848 163.247 129.153 163.995 128.272 163.995H99.5625C98.7241 163.995 98.0444 163.315 98.0444 162.477V151.442Z",
    fill: "#868C98",
    stroke: "#868C98",
    strokeWidth: 2.43243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4219 145.896V157.04",
    stroke: "#868C98",
    strokeWidth: 2.43243
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4215,
    cy: 157.388,
    rx: 2.18275,
    ry: 2.18275,
    fill: "#868C98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240.15 60.3613C240.15 60.3613 225.435 60.4113 225.435 75.0758C225.435 60.4113 210.72 60.3613 210.72 60.3613C210.72 60.3613 225.435 60.3111 225.435 45.6465C225.435 60.3111 240.15 60.3613 240.15 60.3613Z",
    fill: "white",
    stroke: "#868C98",
    strokeWidth: 2.43243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1203 287.026C88.1203 287.026 73.4056 287.076 73.4056 301.741C73.4056 287.076 58.6909 287.026 58.6909 287.026C58.6909 287.026 73.4056 286.976 73.4056 272.312C73.4056 286.976 88.1203 287.026 88.1203 287.026Z",
    fill: "white",
    stroke: "#868C98",
    strokeWidth: 2.43243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 151.938,
    y: 140.522,
    width: 78.8397,
    height: 8.20273,
    rx: 1.85567,
    fill: "#E2E4E9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 151.939,
    y: 154.213,
    width: 46.3028,
    height: 8.20273,
    rx: 1.85567,
    fill: "#E2E4E9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 119.016,
    y: 227.874,
    width: 43.7315,
    height: 8.20273,
    rx: 1.85567,
    fill: "#E2E4E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.881 182.862C132.783 182.862 126.218 189.427 126.218 197.526C126.218 205.624 132.783 212.189 140.881 212.189C148.98 212.189 155.545 205.624 155.545 197.526C155.545 189.427 148.98 182.862 140.881 182.862ZM119.016 197.526C119.016 185.45 128.805 175.66 140.881 175.66C152.957 175.66 162.747 185.45 162.747 197.526C162.747 209.602 152.957 219.392 140.881 219.392C128.805 219.392 119.016 209.602 119.016 197.526Z",
    fill: "#E2E4E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.566 190.161C151.02 185.789 146.291 182.862 140.883 182.862V175.66C148.959 175.66 156.008 180.04 159.79 186.538L153.566 190.161Z",
    fill: "#CDD0D5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 197.266,
    y: 227.874,
    width: 43.7315,
    height: 8.20273,
    rx: 1.85567,
    fill: "#E2E4E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.131 182.862C211.033 182.862 204.468 189.427 204.468 197.526C204.468 205.624 211.033 212.189 219.131 212.189C227.23 212.189 233.795 205.624 233.795 197.526C233.795 189.427 227.23 182.862 219.131 182.862ZM197.266 197.526C197.266 185.45 207.055 175.66 219.131 175.66C231.207 175.66 240.997 185.45 240.997 197.526C240.997 209.602 231.207 219.392 219.131 219.392C207.055 219.392 197.266 209.602 197.266 197.526Z",
    fill: "#E2E4E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.815 190.161C229.269 185.789 224.54 182.862 219.131 182.862V175.66C227.207 175.66 234.256 180.04 238.039 186.538L231.815 190.161Z",
    fill: "#CDD0D5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M223.399 188.508L230.448 178.126L231.4 172.982L214.826 171.553L212.826 179.745L223.399 188.508Z",
    fill: "#868C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStates);
export default __webpack_public_path__ + "static/media/EmptyStates.a8cc7477e0a45402cfe8f81cb73cb790.svg";
export { ForwardRef as ReactComponent };